export type PresignedUrl = {
  part_number: number;
  presigned_url: string;
};

export type MultipartPart = {
  PartNumber: number;
  ETag: string;
};

export type FileInfo = {
  id: string;
  visible_filename: string;
  content_type: string;
};

export type FileInfoDetail = FileInfo & {
  url: string;
};

/**
 * GET /api/v1/files/{id}/
 */
export const GET_FILE_BY_ID_PATH = 'files/{id}/';
export type GetFileByIdRequestPathVariables = { id: string };
export type GetFileByIdRequestQueryParams = undefined;
export type GetFileByIdSuccessDto = FileInfoDetail;
export type GetFileByIdErrorDto = Error;

/**
 * POST /api/v1/files/multipart-upload/generate
 */
export const POST_MULTIPART_UPLOAD_GENERATE_PATH = 'files/multipart-upload/generate';
export type PostMultipartUploadGenerateRequestPathVariables = undefined;
export type PostMultipartUploadGenerateRequestQueryParams = undefined;
export type PostMultipartUploadGenerateRequestBodyData = {
  file_size: number;
  file_name: string;
  content_type: string;
  organization_id: string;
};
export type PostMultipartUploadGenerateSuccessDto = {
  upload_id: string;
  file_name: string;
  bucket: string;
  presigned_urls: PresignedUrl[];
  file_info: string;
};
export type PostMultipartUploadGenerateErrorDto = Error;

/**
 * POST /api/v1/files/multipart-upload/complete
 */
export const POST_MULTIPART_UPLOAD_COMPLETE_PATH = 'files/multipart-upload/complete';
export type PostMultipartUploadCompleteRequestPathVariables = undefined;
export type PostMultipartUploadCompleteRequestQueryParams = undefined;
export type PostMultipartUploadCompleteRequestBodyData = {
  upload_id: string;
  parts: MultipartPart[];
  file_info: string;
};
export type PostMultipartUploadCompleteSuccessDto = {
  file_info: string;
  url: string;
};
export type PostMultipartUploadCompleteErrorDto = Error;

/**
 * POST /api/v1/files/generate-upload-url
 */
export const POST_GENERATE_UPLOAD_URL_PATH = 'files/generate-upload-url';
export type PostGenerateUploadUrlRequestPathVariables = undefined;
export type PostGenerateUploadUrlRequestQueryParams = undefined;
export type PostGenerateUploadUrlRequestBodyData = {
  content_type: string;
  name: string;
  organization_id: string;
};
export type PostGenerateUploadUrlSuccessDto = {
  post_data: {
    url: string;
    fields: Record<string, string>;
  };
  file_id: string;
};
export type PostGenerateUploadUrlErrorDto = Error;
